module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/ClanInfoPanel/images/bg.89c9b2ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/ClanInfoPanel/images/bg.jpg
// module id = 3262
// module chunks = 11